import { createContext, ReactNode, useState } from 'react';
import {
  EditorCtxData,
  LauncherThemeSessionData,
  UIData,
  UserSessionData,
} from '../../types/hooks';
import { userLogin } from './userLogin';
import { userLogout } from './userLogout';

export const EditorCtx = createContext<EditorCtxData | null>(null);

export const EditorProvider = ({ children }: { children: ReactNode }) => {
  const [UI, setUI] = useState({
    theme: 'dark',
    isToolbarExtended: true,
    isSidebarVisible: false,
    sceneIsDragging: false,
    isOnboardingModalOpen: false,
  } as UIData);

  const [userSession, setUserSession] = useState({
    isLoggedIn: null,
    isAuthorized: null,
    email: null,
  } as UserSessionData);

  const [launcherThemeSession, setLauncherThemeSession] = useState({
    isThemeLoaded: false,
    themeID: null,
    versionID: null,
    versions: [],
    images: [],
  } as LauncherThemeSessionData);

  return (
    <EditorCtx.Provider
      value={{
        UI,
        setUI,

        userSession,
        setUserSession,

        launcherThemeSession,
        setLauncherThemeSession,

        userLogin: () => userLogin({ setUserSession }),
        userLogout: () =>
          userLogout({ setUserSession, setLauncherThemeSession }),
      }}
    >
      {children}
    </EditorCtx.Provider>
  );
};
